module.exports = __webpack_public_path__ + "img/ruler&pen.765ef1a5.svg";